import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { NgZorroModule } from '../../shared/NG-Zorro-Antd/ng-zorro-antd.module';
import { DashboardComponent } from './Components/dashboard.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [
    DashboardComponent,

  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    NgZorroModule,
    FontAwesomeModule
  ],
  providers: [
  ]
})
export class DashboardModule { }
